var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { darkThemeStyle, theme } from '../../../theme';
function DataCampLogomark(_a) {
    var _b = _a.inverted, inverted = _b === void 0 ? false : _b, _c = _a.monochrome, monochrome = _c === void 0 ? false : _c, restProps = __rest(_a, ["inverted", "monochrome"]);
    var logomarkColor = monochrome ? theme.brand.text : theme.brand.main;
    return (_jsx("svg", __assign({ css: inverted && darkThemeStyle, viewBox: "0 0 27 35", xmlSpace: "preserve", xmlns: "http://www.w3.org/2000/svg" }, restProps, { children: _jsx("path", { clipRule: "evenodd", d: "M11.699 8.514v8.333L2.858 21.89V3.44l8.841 5.074zm2.861 17.507v-7.51l11.84-6.757-2.88-1.65-8.96 5.112V7.68a1.442 1.442 0 0 0-.718-1.242L3.056.256C3.027.238 2.998.224 2.97.21A2.064 2.064 0 0 0 0 2.07v21.184a2.067 2.067 0 0 0 2.971 1.865l.082-.042 8.64-4.933v6.72c.002.513.277.987.722 1.243L23.502 34.4l2.88-1.651-11.822-6.728z", fill: logomarkColor, fillRule: "evenodd" }) })));
}
export default DataCampLogomark;
